module.exports = __webpack_public_path__ + "static/hero-a647e11f08fc45cfd21ef87848a54baf.jpg";